import { Controller } from '@hotwired/stimulus';
import aiIconImg from '../../assets/images/ai-guide.svg';
import purpleSparkIcon from '../../assets/images/icons/purple-spark.svg';

export default class extends Controller {
  static values = {
    userId: String
  }

  connect() {
    if (!localStorage.getItem(`adventureGuideTooltipSeen_${this.userIdValue}`)) {
      this.showTooltip();
    }
  }

  showTooltip() {
    this.element.innerHTML = `
      <div class="absolute z-50 left-0 mt-8 md:mx-0 mx-6 w-[324px] rounded-2xl border-2 border-purple-200 bg-white shadow-xl p-4 flex flex-col gap-4 text-14">
        <div class="flex items-start gap-3">
          <img src=${aiIconImg} alt="Adventure Guide" class="w-14 h-14" />
          <div>
            <div class="font-bold text-lg text-gray-900 mb-1">Hey there</div>
            <div class="text-gray-700 mb-2">Do you need help finding fun activities for summer?</div>
            <a href="/adventure-guide" target="_blank" data-action="click->adventure-tooltip#setAsSeen" class="text-purple-700 font-semibold hover:underline">Let's chat &rarr;</a>
          </div>
          <button data-action="click->adventure-tooltip#dismiss" class="ml-auto text-gray-400 hover:text-gray-600 text-32 leading-none">&times;</button>
        </div>
        <div class="hidden">
          <div class="flex items-center gap-2 mb-2">
            <img src=${purpleSparkIcon} alt="" class="w-4 h-4" />
            <span class="font-medium text-gray-800">Suggestions</span>
            <span class="px-2 bg-purple-50 text-[8px] mb-1 text-purple-700 rounded-md font-semibold">AI</span>
          </div>
          <div class="flex gap-2 overflow-x-auto no-scrollbar">
            <div class="flex-shrink-0 rounded-full bg-gray-100 px-4 py-2 text-gray-800 font-medium hover:bg-purple-50 transition cursor-pointer whitespace-nowrap">What's still open at OMSI?</div>
            <div class="flex-shrink-0 rounded-full bg-gray-100 px-4 py-2 text-gray-800 font-medium hover:bg-purple-50 transition cursor-pointer whitespace-nowrap">Camps the week of June...</div>
          </div>
        </div>
      </div>
    `;
  }

  setAsSeen() {
    localStorage.setItem(`adventureGuideTooltipSeen_${this.userIdValue}`, 'true');
    this.element.innerHTML = '';
  }

  dismiss() {
    this.element.innerHTML = `
      <div class="absolute z-50 left-0 mt-8 md:mx-0 mx-6 w-[324px] rounded-2xl border-2 border-purple-200 bg-white shadow-xl p-5 text-center text-lg text-gray-900">
        I'll be here if you need me
      </div>
    `;

    setTimeout(this.setAsSeen.bind(this), 5000);
  }
}
